import { Component } from '@angular/core';
import {BotiquinEmpresarialHeroComponent} from "./botiquin-empresarial-hero/botiquin-empresarial-hero.component";
import {InfoComponent} from "../home/info/info.component";
import {ImportantBEComponent} from "./important-be/important-be.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";

@Component({
  selector: 'app-botiquin-empresarial',
  standalone: true,
  imports: [
    BotiquinEmpresarialHeroComponent,
    InfoComponent,
    ImportantBEComponent,
    FooterPersonaComponent
  ],
  templateUrl: './botiquin-empresarial.component.html',
  styleUrl: './botiquin-empresarial.component.css'
})
export class BotiquinEmpresarialComponent {


}
